/* eslint-disable global-require */
const List = () => import('./main.vue');

export default [
  {
    name: 'relatorio/prestador-tabela-preco-contratado',
    path: '/relatorio/prestador-tabela-preco-contratado',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Tabela Preço Contratado',
      icon: 'file-excel',
      can: 'rep316',
      on: 'report',
      client: 'xapsisx',
    },
  },
  {
    name: 'relatorio/prestador-tabela-preco-contratado-logado',
    path: '/relatorio/prestador-tabela-preco-contratado',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Tabela Preço Contratado',
      icon: 'table',
      can: 'list',
      on: 'prestadorlogado',
      filho: true,
      neto: false,
      client: 'xapsisx',
    },
    children: [],
  },
];
